import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { PieceShowcaseRenderComponent } from './piece-showcase-render.component';
import { GetAvailableLinkedProductsPipe, GetLinkedProductByIdPipe } from './pipes/linked-product.pipe';


export const pieceShowcaseRenderModuleEntryComponents = [
  PieceShowcaseRenderComponent
];

@NgModule({
  imports: [
    LazyLoadModule,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: [
    ...pieceShowcaseRenderModuleEntryComponents,
    GetLinkedProductByIdPipe,
    GetAvailableLinkedProductsPipe
  ]
})
export class PieceShowcaseRenderModule {}

export default pieceShowcaseRenderModuleEntryComponents;
